import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { TestAccession } from '../models/TestAccession';
import { ResultCumulative } from '../models/ResultCumulative';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { PlatformLocation } from '@angular/common';

@Injectable()
export class TestResultService {

  constructor(private http: HttpClient, private location: PlatformLocation) {
  }

  getTestAccession(id: string): Observable<TestAccession> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", 'Bearer ' + JSON.parse(sessionStorage.getItem('token')).access_token);
    headers = headers.append("Content-Type", "application/json");

    return this.http.get<TestAccession>(this.location.getBaseHrefFromDOM() + 'api/testresults/' + id, { headers: headers });
  }
  /*
  getTestResults(searchCriteria, page): Observable<TestAccession[]> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", 'Bearer ' + JSON.parse(sessionStorage.getItem('token')).access_token);
    headers = headers.append("Content-Type", "application/json");
    const source = JSON.parse(sessionStorage.getItem('source')).Id;
    let params: HttpParams = new HttpParams();
    if (searchCriteria) {
      params = params.set("fromDate", searchCriteria.fromDate);
      params = params.set("toDate", searchCriteria.toDate);
      params = params.set("reference", searchCriteria.reference);
      params = params.set("hospitalNum", searchCriteria.hospitalNum);
      params = params.set("labNumber", searchCriteria.labNumber);
      params = params.set("surname", searchCriteria.surname);
      params = params.set("forename", searchCriteria.forename);
      params = params.set("dob", searchCriteria.dob);
      params = params.set("testCode", searchCriteria.testCode);
      params = params.set("SourceId", source);
      params = params.set("page", page);
    }
    return this.http.get<TestAccession[]>(this.location.getBaseHrefFromDOM() + 'api/testresults', { headers: headers, params: params });
  }
  */

  getTestResults(searchCriteria, sortBy, sortType, page): Observable<TestAccession[]> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", 'Bearer ' + JSON.parse(sessionStorage.getItem('token')).access_token);
    headers = headers.append("Content-Type", "application/json");
    const source = JSON.parse(sessionStorage.getItem('source')).Id;
    let params: HttpParams = new HttpParams();
    if (searchCriteria) {
      params = params.set("fromDate", searchCriteria.fromDate);
      params = params.set("toDate", searchCriteria.toDate);
      params = params.set("reference", searchCriteria.reference);
      params = params.set("hospitalNum", searchCriteria.hospitalNum);
      params = params.set("labNumber", searchCriteria.labNumber);
      params = params.set("surname", searchCriteria.surname);
      params = params.set("forename", searchCriteria.forename);
      params = params.set("dob", searchCriteria.dob);
      params = params.set("testCode", searchCriteria.testCode);
      params = params.set("SourceId", source);
      params = params.set("page", page);
      params = params.set("sortBy", sortBy);
      params = params.set("sortType", sortType);
    }
    return this.http.get<TestAccession[]>(this.location.getBaseHrefFromDOM() + 'api/testresults', { headers: headers, params: params });
  }

  getTestResultsCumulative(searchCriteria): Observable<ResultCumulative[]> {
    //"/api/testresultscumul"
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", 'Bearer ' + JSON.parse(sessionStorage.getItem('token')).access_token);
    headers = headers.append("Content-Type", "application/json");
    let params: HttpParams = new HttpParams();
    if (searchCriteria) {
      params = params.set("surname", searchCriteria.surname);
      params = params.set("forename", searchCriteria.forename);
      params = params.set("dob", searchCriteria.dob);
      params = params.set("testCode", searchCriteria.testCode);
      params = params.set("fromDate", searchCriteria.fromDate);
      params = params.set("toDate", searchCriteria.toDate);
    }
    return this.http.get<ResultCumulative[]>(this.location.getBaseHrefFromDOM() + 'api/testresultscumul', { headers: headers, params: params });
  }
}
